import { render, staticRenderFns } from "./KejadianPenting.vue?vue&type=template&id=a715deba&scoped=true&"
import script from "./KejadianPenting.vue?vue&type=script&lang=js&"
export * from "./KejadianPenting.vue?vue&type=script&lang=js&"
import style0 from "./KejadianPenting.vue?vue&type=style&index=0&id=a715deba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a715deba",
  null
  
)

export default component.exports